import React from "react";

export const CategoryOne = () => <h1>CategoryOne</h1>
